







































export default

	name: 'IconCard'

	props:
		balanceText:
			type: Boolean
			default: true

		card: Object

		# Card Layout:
		#   Large: Big icon. Icon is always above text.
		#   Small: Smaller icon.  Icon is above text on desktop.  Icon is beside text on mobile.
		layout:
			type: String
			default: 'large'
			validator: (val) -> val in ['large', 'small']

	computed:

		link: -> @card.href || null

		classes: -> [
			# For styling the icon
			"iconsize-#{@layout?.toLowerCase()}"
			# For adding hover effect only if the card is a link
			if @card.href then 'has-link' else 'no-link'
		]

